export default {
  WEB: 'Web',
  MOBILE: 'Mobile',
  CROSS_PLATFORM: 'CrossPlatform'
};
